export const splitWithQuotes = (str: string) => {
	const regex = /(?:[^\s"']+|"[^"]*"|'[^']*'|["'][^"']*$)/g;
	const matches = str.match(regex) || [];

	// Vérification des guillemets non fermés
	for (let i = 0; i < matches.length; i++) {
		const match = matches[i];
		if (
			(match.startsWith('"') && !match.endsWith('"')) ||
			(match.startsWith("'") && !match.endsWith("'"))
		) {
			return null;
		}
	}

	return matches.map((match) => match.replace(/^["']|["']$/g, ""));
};

export const ucFirst = (str: string = "") => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};
